import Vue from 'vue'
import axios from 'axios'
// import {
//   baseURL,
//   contentType,
//   debounce,
//   invalidCode,
//   loginInterception,
//   noPermissionCode,
//   requestTimeout,
//   successCode,
//   tokenName,
//   noToken,
// } from '@/config'
import qs from 'qs'
import store from '@/store'
import { HTTP_API } from './conSysUrl'
import { isArray } from './validate'
let loadingInstance
const successCode = ['200', '0', 200];
/**
 * @author https://github.com/zxwk1998/vue-admin-better （不想保留author可删除）
 * @description 处理code异常
 * @param {*} code
 * @param {*} msg
 */
// const handleCode = (code, msg) => {
//   switch (code) {
//     case invalidCode:
//       Vue.prototype.$baseMessage(msg || `后端接口${code}异常`, 'error')
//       store.dispatch('user/resetAccessToken').catch(() => {})
//       if (loginInterception) {
//         location.reload()
//       }
//       break
//     case noPermissionCode:
//     case 401:
//       router.push({ path: '/401' }).catch(() => {})
//       break
//     case noToken:
//       router.push({ path: '/login' }).catch(() => {})
//       break
//     default:
//       Vue.prototype.$baseMessage(msg || `后端接口${code}异常`, 'error')
//       break
//   }
// }
const instance = axios.create({
  baseURL: HTTP_API,
  timeout: 24000,
  headers: {
    // 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    'Content-Type': 'application/json;charset=UTF-8',
  },
})

instance.interceptors.request.use(
  (config) => {
    if (store.getters['getToken']) {
      config.headers['Authorization'] = 'Bearer '+store.getters['getToken']
    }
    //这里会过滤所有为空、0、false的key，如果不需要请自行注释
    // if (config.data) config.data = Vue.prototype.$baseLodash.pickBy(config.data, Vue.prototype.$baseLodash.identity)
    if (config.data && config.headers['Content-Type'] === 'application/x-www-form-urlencoded;charset=UTF-8')
      config.data = qs.stringify(config.data)
    // if (debounce.some((item) => config.url.includes(item))) loadingInstance = Vue.prototype.$baseLoading()
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
const refToken = async function () {
  // const res = await replaceToken()
  //给store的token赋值
  // store.commit('user/setAccessToken', res.data)
  //打印store的token
  // console.log(store.getters['user/accessToken'], 'store的token')
}
const handleCode = (code, msg) => {
  switch (code) {
    case 402:
      Vue.prototype.$baseMessage(msg || `${code}`, 'error')
      store.dispatch('logout').catch(() => { })
      router.push({ path: '/' }).catch(() => {})
      if (loginInterception) {
        location.reload()
      }
      break
    case 401:
      Vue.prototype.$baseMessage('Login expired, please login again', 'error')
      store.dispatch('logout').catch(() => {})
      if (loginInterception) {
        location.reload()
      }
      break
    // case noPermissionCode:
      
    //   router.push({ path: '/401' }).catch(() => {})
    //   break
    default:
      Vue.prototype.$baseMessage(msg || `${code}`, 'error')
      break
  }
}
instance.interceptors.response.use(
  (response) => {
    if (loadingInstance) loadingInstance.close()
    //刷新token
    // if (response.headers['vol_exp'] && response.headers['vol_exp'] === '1') {
    //   refToken()
    // }
    // console.log(response,'response',response.headers['vol_exp']);
    const { data, config } = response
    const { code, message } = data
    // 操作正常Code数组
    const codeVerificationArray = isArray(successCode) ? [...successCode] : [...[successCode]]
    // 是否操作正常
    if (codeVerificationArray.includes(code)) {
      return data
    } else {
      handleCode(code, message)
       return Promise.reject(`error:${{
        url: config.url,
        code,
        message,
       }}`)
      
      // return Promise.reject(
      //   `error:${JSON.stringify({
      //     url: config.url,
      //     code,
      //     message,
      //   })}` || 'Error'
      // )
    }
  },
  (error) => {
    
    if (loadingInstance) loadingInstance.close()
    const { response, message } = error
      if (error.response && error.response.data) {
        const { status, data } = response
        handleCode(status, data.message || message)
        return Promise.reject(error)
      } else {
        let { message } = error
        if (message === 'Network Error') {
          message = 'Network Error'
        }
        if (message.includes('timeout')) {
          message = 'timeout'
        }
        if (message.includes('Request failed with status code')) {
          const code = message.substr(message.length - 3)
          message = `error code:${code}`
        }
        Vue.prototype.$baseMessage(message || ``, 'error')
  
        return Promise.reject(error)
      }
    

  }
)

export default instance
